export const locKeys = {
  //To do: fill in with actual loc references
  pickUpLocationLabel: "wizard.car.pickUpLocation.label",
  pickUpLocationPlaceholder: "wizard.car.pickUpLocation.placeholder",
  pickUpTimeLabel: "wizard.car.pickUpTime.label",
  pickUpDateLabel: "wizard.car.pickUpDate.label",
  dropOffLocationLabel: "wizard.car.dropOffLocation.label",
  dropOffLocationPlaceholder: "wizard.car.dropOffLocation.placeholder",
  dropOffTimeLabel: "wizard.car.dropOffTime.label",
  dropOffDateLabel: "wizard.car.dropOffDate.label",
  brandSelectionLabel: "wizard.car.brandSelection.label",
  couponCodeSelectionLabel: "wizard.car.couponCodeSelection.label",
  noCode: "wizard.car.couponCode.noCode.text",
  corporateCode: "wizard.car.couponCode.corporateCode.text",
  specialCode: "wizard.car.couponCode.specialCode.text",

  discountRateCode: "wizard.car.couponCode.discountRateCode.label",
  discountCouponCode: "wizard.car.couponCode.discountCouponCode.label",
  corporateDiscountNumber: "wizard.car.couponCode.corporateDiscountNumber.label",
  corporateDiscountCode: "wizard.car.couponCode.corporateDiscountCode.label",
  faststartID: "wizard.car.couponCode.faststartID.label",
  alamoInsiderNumber: "wizard.car.couponCode.alamoInsidersNumber.label",
  awdNumber: "wizard.car.couponCode.AWDNumber.label",
  wizardNumber: "wizard.car.couponCode.wizardNumber.label",
  BCDNumber: "wizard.car.couponCode.BCDNumber.label",
  fastbreakNumber: "wizard.car.couponCode.fastBreakNumber.label",
  dollarExpressNumber: "wizard.car.couponCode.dollarExpressNumber.label",
  customerNumber: "wizard.car.couponCode.customerNumber.label",
  enterprisePlusNumber: "wizard.car.couponCode.enterprisePlus#.label",
  contractNumber: "wizard.car.couponCode.contractNumber.label",
  privilegeNumber: "wizard.car.couponCode.privilegeNumber.label",
  cdp: "wizard.car.couponCode.CDP.label",
  nationalContractID: "wizard.car.couponCode.nationalContractID.label",
  emeraldClubId: "wizard.car.couponCode.emeraldClubID.label",
  corporateAccount: "wizard.car.couponCode.corporateAccount.label",
  paylessPerksNumber: "wizard.car.couponCode.paylessPerksNumber.label",
  blueChipNumber: "wizard.car.couponCode.blueChipNumber.label",

  searchButton: "wizard.submit.label",

  noPreference: "wizard.car.rentalCompany.noPreference.text",
  aceRentACarCompany: "wizard.car.rentalCompany.aceRentACarCompany.text",
  advantageRentACarCompany: "wizard.car.rentalCompany.advantageRentACarCompany.text",
  alamoRentACarCompany: "wizard.car.rentalCompany.alamoRentACarCompany.text",
  avisCompany: "wizard.car.rentalCompany.avisCompany.text",
  budgetCompany: "wizard.car.rentalCompany.budgetCompany.text",
  dollarRentACarCompany: "wizard.car.rentalCompany.dollarRentACarCompany.text",
  economyRentACarCompany: "wizard.car.rentalCompany.economyRentACarCompany.text",
  enterpriseCompany: "wizard.car.rentalCompany.enterpriseCompany.text",
  europcarCompany: "wizard.car.rentalCompany.europcarCompany.text",
  foxRentalCarsCompany: "wizard.car.rentalCompany.foxRentalCarsCompany.text",
  hertzCompany: "wizard.car.rentalCompany.hertzCompany.text",
  midwayCarRentalCompany: "wizard.car.rentalCompany.midwayCarRentalCompany.text",
  nationalCarRentalCompany: "wizard.car.rentalCompany.nationalCarRentalCompany.text",
  nuCarCompany: "wizard.car.rentalCompany.nuCarCompany.text",
  paylessCompany: "wizard.car.rentalCompany.paylessCompany.text",
  routesCarRental: "wizard.car.rentalCompany.routesCarRental.text",
  sixtCompany: "wizard.car.rentalCompany.sixtCompany.text",
  thriftyCarRentalCompany: "wizard.car.rentalCompany.thriftyCarRentalCompany.text",
  uSaveCompany: "wizard.car.rentalCompany.uSaveCompany.text",
  silvercar: "wizard.car.rentalCompany.silvercar.text",

  time: [
    "wizard.time1200AM.text",
    "wizard.time1215AM.text",
    "wizard.time1230AM.text",
    "wizard.time1245AM.text",
    "wizard.time0100AM.text",
    "wizard.time0115AM.text",
    "wizard.time0130AM.text",
    "wizard.time0145AM.text",
    "wizard.time0200AM.text",
    "wizard.time0215AM.text",
    "wizard.time0230AM.text",
    "wizard.time0245AM.text",
    "wizard.time0300AM.text",
    "wizard.time0315AM.text",
    "wizard.time0330AM.text",
    "wizard.time0345AM.text",
    "wizard.time0400AM.text",
    "wizard.time0415AM.text",
    "wizard.time0430AM.text",
    "wizard.time0445AM.text",
    "wizard.time0500AM.text",
    "wizard.time0515AM.text",
    "wizard.time0530AM.text",
    "wizard.time0545AM.text",
    "wizard.time0600AM.text",
    "wizard.time0615AM.text",
    "wizard.time0630AM.text",
    "wizard.time0645AM.text",
    "wizard.time0700AM.text",
    "wizard.time0715AM.text",
    "wizard.time0730AM.text",
    "wizard.time0745AM.text",
    "wizard.time0800AM.text",
    "wizard.time0815AM.text",
    "wizard.time0830AM.text",
    "wizard.time0845AM.text",
    "wizard.time0900AM.text",
    "wizard.time0915AM.text",
    "wizard.time0930AM.text",
    "wizard.time0945AM.text",
    "wizard.time1000AM.text",
    "wizard.time1015AM.text",
    "wizard.time1030AM.text",
    "wizard.time1045AM.text",
    "wizard.time1100AM.text",
    "wizard.time1115AM.text",
    "wizard.time1130AM.text",
    "wizard.time1145AM.text",
    "wizard.time1200PM.text",
    "wizard.time1215PM.text",
    "wizard.time1230PM.text",
    "wizard.time1245PM.text",
    "wizard.time0100PM.text",
    "wizard.time0115PM.text",
    "wizard.time0130PM.text",
    "wizard.time0145PM.text",
    "wizard.time0200PM.text",
    "wizard.time0215PM.text",
    "wizard.time0230PM.text",
    "wizard.time0245PM.text",
    "wizard.time0300PM.text",
    "wizard.time0315PM.text",
    "wizard.time0330PM.text",
    "wizard.time0345PM.text",
    "wizard.time0400PM.text",
    "wizard.time0415PM.text",
    "wizard.time0430PM.text",
    "wizard.time0445PM.text",
    "wizard.time0500PM.text",
    "wizard.time0515PM.text",
    "wizard.time0530PM.text",
    "wizard.time0545PM.text",
    "wizard.time0600PM.text",
    "wizard.time0615PM.text",
    "wizard.time0630PM.text",
    "wizard.time0645PM.text",
    "wizard.time0700PM.text",
    "wizard.time0715PM.text",
    "wizard.time0730PM.text",
    "wizard.time0745PM.text",
    "wizard.time0800PM.text",
    "wizard.time0815PM.text",
    "wizard.time0830PM.text",
    "wizard.time0845PM.text",
    "wizard.time0900PM.text",
    "wizard.time0915PM.text",
    "wizard.time0930PM.text",
    "wizard.time0945PM.text",
    "wizard.time1000PM.text",
    "wizard.time1015PM.text",
    "wizard.time1030PM.text",
    "wizard.time1045PM.text",
    "wizard.time1100PM.text",
    "wizard.time1115PM.text",
    "wizard.time1130PM.text",
    "wizard.time1145PM.text"
  ],

  carTabTitle: "wizard.car.tab.title",

  gtTabTitle: "wizard.gt.tab.title",
  gtSubLOBFrom: "wizard.gt.sublob.from",
  gtSubLOBTo: "wizard.gt.sublob.to",
  gtHeaderFrom: "wizard.gt.header.from",
  gtHeaderTo: "wizard.gt.header.to",
  gtProperty: "wizard.gt.location.property",
  gtAirport: "wizard.gt.localtion.airport",
  gtArrivalTime: "wizard.gt.arrivalTime",
  gtArrivalDate: "wizard.gt.arrivalDate",
  gtDepartureTime: "wizard.gt.departureTime",
  gtDepartureDate: "wizard.gt.departureDate",
  gtRoundtrip: "wizard.gt.bookRoundtrip"
};
